import { Box } from '@mui/material'
import { BlockRenderer } from '@/components/ChatResponseElements'
import { CHAT_THREAD_RESPONSE_COMPONENT_DEMO_BLOCKS } from './chatThreadDemoBlocks.js'
import outputStyles from './chatThreadAssistantOutput.module.scss'

/** Branch 2: server- or demo-supplied typed blocks with no phase1 metadata. */
export function AssistantBlocksBody({ blocks, streaming, onAgentQuestionSelect }) {
  return (
    <Box
      className={`${outputStyles.agentOutput}${streaming ? ` ${outputStyles.agentOutputStreaming}` : ''}`}
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}
    >
      <BlockRenderer
        blocks={blocks}
        streaming={streaming}
        onAgentQuestionSelect={onAgentQuestionSelect}
      />
    </Box>
  )
}

/** Branch 3: the `RESPONSE_COMPONENT_DEMO` sentinel prompt. */
export function AssistantDemoBody() {
  return (
    <Box
      className={outputStyles.agentOutput}
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}
    >
      <BlockRenderer blocks={CHAT_THREAD_RESPONSE_COMPONENT_DEMO_BLOCKS} />
    </Box>
  )
}
